import { Injectable } from '@angular/core';
import { OclGlobalInstructionTagService } from 'src/app/ocl/services/ocl-global-instruction-tag-service/ocl-global-instruction-tag.service';

@Injectable({
  providedIn: 'root',
})
export class EclGlobalInstructionTagService extends OclGlobalInstructionTagService {
  // tslint:disable:variable-name
  protected ParseGlobalInstructionTag = Parse.Object.extend('ECLGlobalInstructionTag');
  protected ParseGlobalInstruction = Parse.Object.extend('ECLGlobalInstruction');
  protected ParseTag = Parse.Object.extend('ECLTag');
  // tslint:enable
}
